/**
 *
 * LoadingAnimation
 *
 */

import * as PropTypes from "prop-types";
import styled, {keyframes} from "styled-components";
import {styling} from "styling";

const DURATION = 1000;
const MIN_SCALE = 0.4;
const MAX_SCALE = 1;

const DEFAULT_SIZE = 15;

export default function LoadingAnimation({
  contained,
  containedVertical,
  size,
}) {
  return (
    <Wrapper
      contained={contained}
      containedVertical={containedVertical}
      data-cy="loadingAnimation"
    >
      <Dot size={size} delay={0} color={styling.blue} />
      <Dot size={size} delay={DURATION * 0.25} color={styling.orange} />
      <Dot size={size} delay={DURATION * 0.5} color={styling.green} />
    </Wrapper>
  );
}

LoadingAnimation.propTypes = {
  contained: PropTypes.bool,
  containedVertical: PropTypes.bool,
  size: PropTypes.number,
};

LoadingAnimation.defaultProps = {
  size: DEFAULT_SIZE,
};

const pulse = keyframes`
  from {
    transform: scale(${MIN_SCALE});
  }

  40% {
    transform: scale(${MAX_SCALE});
  }

  95% {
    transform: scale(${MAX_SCALE});
  }

  to {
    transform: scale(${MIN_SCALE});
  }
`;

const Dot = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  animation: ${pulse} 1s linear infinite;
  animation-delay: ${({ delay }) => delay}ms;
  margin-left: ${({ size }) => size / 2}px;
  &:first-child {
    margin-left: 0;
  }
`;

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.padding}rem;
  display: flex;

  ${({ containedVertical }) => containedVertical && "height: 100%"};

  ${({ contained }) =>
    contained
      ? `
    width: 100%;
    justify-content: center;

    align-items: center;
  `
      : ""};
`;
